var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ClevertapEventsService } from '../services/clevertap.service';
import { SessionService } from '../services/session.service';
import * as JSZip from 'jszip';
import * as FileSaver from 'file-saver';
import { ToasterService } from 'angular2-toaster';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./session.service";
import * as i3 from "angular2-toaster/src/toaster.service";
var CandidatesService = /** @class */ (function () {
    function CandidatesService(http, sessionService, toasterService) {
        this.http = http;
        this.sessionService = sessionService;
        this.toasterService = toasterService;
        this.massiveDownload = new BehaviorSubject({
            label: 'Download',
            loading: false
        });
        this.massiveDownload$ = this.massiveDownload.asObservable();
    }
    // (unpaginated)
    CandidatesService.prototype.getAll = function (body, page, limit) {
        if (body === void 0) { body = {}; }
        console.log(body, page, limit);
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/curricula/";
        if (page >= 0) {
            url += "?page=" + page;
            if (limit) {
                url += "&size=" + limit;
            }
        }
        return this.http.post(url, body);
    };
    CandidatesService.prototype.getTalentPool = function (body, page, limit) {
        if (body === void 0) { body = {}; }
        console.log(body, page, limit);
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/curricula/talent-pool/";
        if (page >= 0) {
            url += "?page=" + page;
            if (limit) {
                url += "&limit=" + limit;
            }
        }
        return this.http.post(url, body);
    };
    CandidatesService.prototype.exportTool = function (filters) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + environment.baseUrlWs + environment.wsVerison + "employer/curricula/export-pool";
                        return [4 /*yield*/, this.http.post(url, filters, { responseType: 'blob' }).toPromise()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CandidatesService.prototype.getTagsList = function () {
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/tags-list";
        return this.http.get(url);
    };
    CandidatesService.prototype.getCandidatesFromFilters = function (params) {
        var normalizedParams = {};
        for (var i in params) {
            if (params.hasOwnProperty(i) && params[i]) {
                var np = params[i];
                if (params[i].value) {
                    np = params[i].value;
                }
                normalizedParams[i] = np;
            }
        }
        return this.http.get(environment.baseUrlWs + environment.wsVerison + 'employer/curricula/all/?status=' + normalizedParams['status'] +
            (normalizedParams['username'] ? '&username=' + normalizedParams['username'] : '') +
            (normalizedParams['job_offers_id'] ? '&job_offers_id=' + normalizedParams['job_offers_id'] : '') +
            (normalizedParams['university'] ? '&university=' + normalizedParams['university'] : '') +
            (normalizedParams['skill'] ? '&skill=' + normalizedParams['skill'] : '') +
            (normalizedParams['city'] ? '&city=' + normalizedParams['city'] : '') +
            (normalizedParams['vote'] ? '&vote=' + normalizedParams['vote'] : '') +
            (normalizedParams['faculty_tag'] ? '&faculty_tag=' + normalizedParams['faculty_tag'] : '') +
            (normalizedParams['language'] ? '&language=' + normalizedParams['language'] : '') +
            (normalizedParams['language_level'] ? '&language_level=' + normalizedParams['language_level'] : ''));
    };
    CandidatesService.prototype.openCurriculaFromFilters = function (params) {
        var options = { responseType: 'text' };
        var normalizedParams = {};
        for (var i in params) {
            if (params.hasOwnProperty(i) && params[i]) {
                var np = params[i];
                if (params[i].value) {
                    np = params[i].value;
                }
                normalizedParams[i] = np;
            }
        }
        return this.http.get(environment.baseUrlWs + environment.wsVerison + 'employer/curricula/open-cv-list/?status=' + normalizedParams['status'] +
            (normalizedParams['username'] ? '&username=' + normalizedParams['username'] : '') +
            (normalizedParams['job_offers_id'] ? '&job_offers_id=' + normalizedParams['job_offers_id'] : '') +
            (normalizedParams['university'] ? '&university=' + normalizedParams['university'] : '') +
            (normalizedParams['skill'] ? '&skill=' + normalizedParams['skill'] : '') +
            (normalizedParams['city'] ? '&city=' + normalizedParams['city'] : '') +
            (normalizedParams['vote'] ? '&vote=' + normalizedParams['vote'] : '') +
            (normalizedParams['faculty_tag'] ? '&faculty_tag=' + normalizedParams['faculty_tag'] : '') +
            (normalizedParams['language'] ? '&language=' + normalizedParams['language'] : '') +
            (normalizedParams['language_level'] ? '&language_level=' + normalizedParams['language_level'] : ''), options);
    };
    CandidatesService.prototype.downloadPdf = function (id) {
        return this.http.get(environment.baseUrlApiAppUsers + "employer/user/" + id + "/print?language=it", { responseType: 'arraybuffer' });
    };
    CandidatesService.prototype.downloadMassive = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var stored, sanitizedFilters, candidates, totCandidates, candidatesId, results, _loop_1, _i, candidatesId_1, c, zip, i, that_1;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.massiveDownload.next({
                                        loading: true,
                                        label: 'Preparing ...'
                                    });
                                    stored = this.sessionService.get('candidates_filters') ? JSON.parse(this.sessionService.get('candidates_filters')) : {};
                                    sanitizedFilters = JSON.parse(JSON.stringify(stored));
                                    if (sanitizedFilters['job_offers_id']) {
                                        sanitizedFilters['job_offers_id'] = sanitizedFilters['job_offers_id'].value;
                                    }
                                    if (sanitizedFilters['languages_id']) {
                                        sanitizedFilters['languages_id'] = Number(sanitizedFilters['languages_id'].value);
                                    }
                                    if (sanitizedFilters['language_level']) {
                                        sanitizedFilters['language_level'] = Number(sanitizedFilters['language_level'].value);
                                    }
                                    if (sanitizedFilters['cities_ids'] && sanitizedFilters['cities_ids'][0]) {
                                        sanitizedFilters['cities_ids'][0] = sanitizedFilters['cities_ids'][0].id;
                                    }
                                    if (sanitizedFilters['universities_ids'] && sanitizedFilters['universities_ids'][0]) {
                                        sanitizedFilters['universities_ids'][0] = sanitizedFilters['universities_ids'][0].id;
                                    }
                                    if (sanitizedFilters['faculty_tags'] && sanitizedFilters['faculty_tags'][0]) {
                                        sanitizedFilters['faculty_tags'][0] = sanitizedFilters['faculty_tags'][0].id;
                                    }
                                    if (sanitizedFilters['tags_ids'] && sanitizedFilters['tags_ids'][0]) {
                                        sanitizedFilters['tags_ids'][0] = sanitizedFilters['tags_ids'][0].id;
                                    }
                                    else {
                                        delete sanitizedFilters['tags_ids'];
                                    }
                                    if (sanitizedFilters['skills_ids'] && sanitizedFilters['skills_ids'][0]) {
                                        sanitizedFilters['skills_ids'][0] = sanitizedFilters['skills_ids'][0].id;
                                    }
                                    return [4 /*yield*/, this.getAll(sanitizedFilters, 0, 500).toPromise()];
                                case 1:
                                    candidates = _a.sent();
                                    totCandidates = candidates.rows.length;
                                    candidatesId = [];
                                    ClevertapEventsService.emitEvent('downloadCVs', { total: candidates.rows.length });
                                    candidates.rows.map(function (c) { return candidatesId.push({
                                        call: _this.downloadPdf(c.User.id),
                                        fileName: c.User.id + "-" + c.User.name + "-" + c.User.surname
                                    }); });
                                    results = [];
                                    _loop_1 = function (c) {
                                        var result;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                                                        _this.massiveDownload.next({
                                                            label: "Downloading " + (results.length + 1) + " of " + totCandidates + " ...",
                                                            loading: true
                                                        });
                                                        return c.call.toPromise().then(function (r) { return resolve(r); }).catch(function (e) { return resolve(null); });
                                                    })];
                                                case 1:
                                                    result = _a.sent();
                                                    if (result) {
                                                        results.push({
                                                            file: result,
                                                            fileName: c.fileName
                                                        });
                                                    }
                                                    return [2 /*return*/];
                                            }
                                        });
                                    };
                                    _i = 0, candidatesId_1 = candidatesId;
                                    _a.label = 2;
                                case 2:
                                    if (!(_i < candidatesId_1.length)) return [3 /*break*/, 5];
                                    c = candidatesId_1[_i];
                                    return [5 /*yield**/, _loop_1(c)];
                                case 3:
                                    _a.sent();
                                    _a.label = 4;
                                case 4:
                                    _i++;
                                    return [3 /*break*/, 2];
                                case 5:
                                    if (results.length > 0) {
                                        this.massiveDownload.next({
                                            label: totCandidates + " downloaded ...",
                                            loading: true
                                        });
                                        zip = new JSZip();
                                        for (i = 0; i < results.length; i++) {
                                            zip.file(results[i].fileName + ".pdf", new Blob([results[i].file], { type: 'application/pdf' }), {});
                                        }
                                        this.massiveDownload.next({
                                            label: "Starting generating Zip File ...",
                                            loading: true
                                        });
                                        that_1 = this;
                                        zip.generateAsync({ type: "blob" })
                                            .then(function (content) {
                                            FileSaver.saveAs(content, "pdf-cv-export.zip");
                                            that_1.massiveDownload.next({
                                                label: "Download",
                                                loading: false
                                            });
                                            resolve(true);
                                        }).catch(function (e) {
                                            that_1.massiveDownload.next({
                                                label: "Download",
                                                loading: false
                                            });
                                            reject();
                                        });
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    CandidatesService.ngInjectableDef = i0.defineInjectable({ factory: function CandidatesService_Factory() { return new CandidatesService(i0.inject(i1.HttpClient), i0.inject(i2.SessionService), i0.inject(i3.ToasterService)); }, token: CandidatesService, providedIn: "root" });
    return CandidatesService;
}());
export { CandidatesService };
